import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { dateToString, getFullName } from '@/utils';
import { useGetParentAdoptionsQuery } from '@/services/parent-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Child',
    key: 'child',
    render: (_, record) => <Link to={`/child/${record.childId}`}>{getFullName(record)}</Link>,
  },
  {
    title: 'Adoption Date',
    dataIndex: 'adoptedDate',
    render: (value) => dateToString(value),
  },
  {
    title: 'Type',
    dataIndex: 'adoptionType',
    render: (value) => value.name,
  },
  {
    title: 'Note',
    dataIndex: 'note',
    ellipsis: true,
  },
];

const AdoptionHistory = ({ parentId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetParentAdoptionsQuery({ parentId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childAdoptionId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(AdoptionHistory);
